<template>
  <div
    v-if="timeTravel"
    class="fixed-top"
    style="z-index: 10000"
  >
    <div class="row q-gutter-xs justify-center items-center">
      <q-btn
        icon="update"
        size="sm"
        text-color="white"
        dense
        @click="editPreviewDate = true"
      />
      <q-btn
        icon="remove"
        size="sm"
        text-color="white"
        dense
        @click="adjustDate(-1)"
      />
      <div
        class="text-white"
        @click="editPreviewDate = true"
      >
        {{ currentSite.previewTime.format('ddd, MMM Do') }}
      </div>
      <q-btn
        icon="add"
        size="sm"
        text-color="white"
        dense
        @click="adjustDate(1)"
      />
      <q-btn
        icon="close"
        size="sm"
        text-color="white"
        dense
        @click="stopTimeTravel()"
      />
    </div>
    <q-dialog v-model="editPreviewDate">
      <q-date
        :model-value="currentSite.previewTime"
        @update:model-value="setPreviewDate"
      />
    </q-dialog>
  </div>
</template>

<script>

import { date } from 'quasar'
const { addToDate } = date

import { IsoDateTime } from 'src/models/Model'

export default {
  name: 'StartTimeTravel',
  data () {
    return {
      editPreviewDate: false,
      timeTravel: false
    }
  },

  configuration: ['currentSite'],

  methods: {
    startTimeTravel () {
      this.timeTravel = true
      const tomorrow = addToDate(new Date(), { date: 1 })
      this.currentSite.previewTime = new IsoDateTime(tomorrow)
    },
    adjustDate (days) {
      this.currentSite.previewTime = new IsoDateTime(addToDate(this.currentSite.previewTime, { date: days }))
    },
    stopTimeTravel () {
      this.timeTravel = false
      this.currentSite.previewTime = null
    },
    setPreviewDate (date) {
      this.currentSite.previewTime = new IsoDateTime(date)
      this.editPreviewDate = false
    }
  }
}
</script>
